import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/anim/loading.json';

const Loading = () => {
    return (
        <div style={fullscreenOverlay}>
            <Lottie animationData={animationData} loop={true} />
        </div>
    );
};

const fullscreenOverlay = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export default Loading;